import React from 'react';
import moment from 'moment';

const InfoDateAmount = ({
  bookedDateTime,
  tripStatus,
  cancelledBy,
  tripDate,
  tripTime,
  tripFare,
  backgroundType,
  backgroundURL,
  thumbnailImage,
}) => {
  const formattedDate = moment(tripDate).utcOffset("+05:30").format('Do MMMM YYYY');
  const formattedTime = moment(tripTime).utcOffset("+05:30").format('h:mm A');
  // const backgroundImage = backgroundType === 'IMAGE' && backgroundURL ? backgroundURL : thumbnailImage;
const backgroundImage=thumbnailImage;
console.log("thumbnailImage",thumbnailImage)

  console.log("backgroundURL",backgroundURL)
  console.log("backgroundType",backgroundType)
  const whoCancelled = !cancelledBy
    ? ''
    : cancelledBy === 'driver'
    ? 'Cancelled by Partner'
    : cancelledBy === 'user'
    ? 'Cancelled by You'
    : `${tripStatus} - ${cancelledBy}`;

  return (
    <div className="flex flex-col p-4 rounded-md border shadow-md w-full">
      <div className="w-full h-40 rounded-md overflow-hidden">
        <img src={thumbnailImage} alt="Poster" className="w-full h-full object-cover" />
      </div>

      <div className="flex justify-between items-center mt-4">
        <div>
          <p className="text-sm">Booked on {moment(bookedDateTime).format('DD MMM YYYY')} • {moment(bookedDateTime).format('hh:mm A')}</p>
          <p className={`text-sm font-medium ${tripStatus === 'CANCELLED' ? 'text-red-500' : 'text-green-500'}`}>{tripStatus === 'CANCELLED' ? whoCancelled : tripStatus}</p>
        </div>
        <div className="text-right">
          <p className="text-sm">Amount</p>
          <p className="text-lg font-bold">₹ {tripFare}</p>
        </div>
      </div>

      <div className="flex justify-between items-center mt-4 border-t pt-2">
        <div className="flex flex-col items-center">
          <p className="text-sm">Scheduled for</p>
          <p className="text-base font-semibold">{formattedDate}</p>
        </div>
        <div className="w-1 h-8 bg-gray-400"></div>
        <div className="flex flex-col items-center">
          <p className="text-sm">Scheduled Time</p>
          <p className="text-base font-semibold">{formattedTime}</p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(InfoDateAmount);